// 登录相关的接口
import fetch from './tjFetch.js'
import abLS from '@/business/abLocalStorage'
import { DeviceUUID } from 'device-uuid'

const apiConfig = {
  // 登录
  login: `/api/pms/user/login.api`,
  // 发送验证码
  send: `/api/pms/sms/send.api`,
  sendForRegist: `/api/pms/sms/sendSms.api`,
  // 登出
  logout: `/api/pms/user/logout.api`,
  // 修改手机号
  changeMobile: `/api/pms/user/changeMobile.api`,
  // 图形验证码
  imageApply: `/api/pms/sms/imageApply.api`,
  // 查询用户是否绑定公众号
  checkUserIsBindWechart: `/api/pms/wechatManage/info.api`,
  // 解绑门店公众号
  unBindWechart: `/api/pms/wechatManage/unbind.api`,
  // 获取公众号绑定二维码
  getWechartQRcode: `/api/pms/wechatManage/pic.api`,
  // 获取微信登录二维码
  getWxLoginQrcode: `/api/pms/user/qrcode.api`,
  // 轮询微信是否扫码登录
  checkWxLogin: `/api/pms/user/checkauth.api`,
  // 手机号注册
  phoneRegist: `/api/pms/user/register.api`
}

const api = {}

const getData = (fromData) => {
  const config = {
    headers: {
      'accessToken': abLS.getAccessToken() || '',
      'deviceId': new DeviceUUID().get()
    }
  }
  const data = {
    data: fromData || {},
    params: fromData && fromData.params,
    ...config,
    withCredentials: true
  }
  return data
}
// 登录
api.login = function(fromData) {
  return fetch.post(apiConfig.login, getData(fromData))
}
// 退出登录
api.logout = function(fromData) {
  return fetch.post(apiConfig.logout, getData(fromData))
}
// 短信验证码
api.send = function(fromData) {
  return fetch.post(apiConfig.send, getData(fromData))
}
// 更换手机号
api.changeMobile = function(fromData) {
  return fetch.post(apiConfig.changeMobile, getData(fromData))
}
// 更换手机号
api.imageApply = function(fromData) {
  return fetch.post(apiConfig.imageApply, getData(fromData))
}
// 查询用户是否绑定公众号
api.checkUserIsBindWechart = function(fromData) {
  return fetch.post(apiConfig.checkUserIsBindWechart, getData(fromData))
}
// 解绑门店公众号
api.unBindWechart = function(fromData) {
  return fetch.post(apiConfig.unBindWechart, getData(fromData))
}
// 获取公众号绑定二维码
api.getWechartQRcode = function(fromData) {
  return fetch.post(apiConfig.getWechartQRcode, getData(fromData))
}
api.getWxLoginQrcode = function(fromData) {
  return fetch.get(apiConfig.getWxLoginQrcode, getData(fromData))
}
api.checkWxLogin = function(params) {
  return fetch.post(apiConfig.checkWxLogin, getData({ params, noLoading: true }))
}
api.phoneRegist = function(fromData) {
  return fetch.post(apiConfig.phoneRegist, getData(fromData))
}
api.sendForRegist = function(fromData) {
  return fetch.post(apiConfig.sendForRegist, getData(fromData))
}

export default api
